import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import tw from 'twin.macro';
import { css } from "styled-components/macro";
import Swiper from 'swiper/swiper-react-hack.js';
import SwiperSlide from 'swiper/swiperslide-react-hack.js';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/swiper.min.css';
import 'swiper/modules/pagination.min.css';
import 'swiper/modules/navigation.css';
import { Container as ContainerBase, Content2Xl } from "components/misc/Layouts.js";
import { Subheading, SectionHeadingH2 } from "components/misc/Headings.js";

const Container = tw(ContainerBase)``;
const Heading = tw(SectionHeadingH2)`w-full text-left text-gray-800`;
const SubHeading = tw(Subheading)`text-center mb-8 text-gray-600 font-normal`;

const ProjectCardStyle = {
  borderRadius: '0.75rem',
  padding: '1.5rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  background: '#4A5568',
  transition: 'all 0.3s ease-in-out',
  transform: 'scale(1)',
};

const ProjectCardHoverStyle = {
  transform: 'scale(1.05)',
  boxShadow: '0 15px 25px rgba(0, 0, 0, 0.15)',
};

const CategoryLabelStyle = {
  position: 'absolute',
  top: '0.75rem',
  right: '0.75rem',
  backgroundColor: 'rgba(255, 255, 255, 0.2)',
  color: 'white',
  padding: '0.25rem 0.5rem',
  borderRadius: '0.25rem',
  fontSize: '0.75rem',
  fontWeight: 600,
  textTransform: 'uppercase',
};



const ProjectDescriptionStyle = {
  color: 'rgba(255, 255, 255, 0.85)',
  marginBottom: '1.25rem',
  fontSize: '0.875rem',
};

const ReadMoreButtonStyle = {
  alignSelf: 'center',
  marginTop: '1rem',
  padding: '0.5rem 1.5rem',
  backgroundColor: '#4a90e2',
  color: 'white',
  fontSize: '0.875rem',
  borderRadius: '0.5rem',
  border: 'none',
  cursor: 'pointer',
  transition: 'background-color 0.3s ease, transform 0.3s ease',
};

const ReadMoreButtonHoverStyle = {
  backgroundColor: '#357ABD',
  transform: 'translateY(-3px)',
};

const CommunityProjects = ({ translations }) => {
  const { heading, subheading, projects } = translations.devCommunity.communityProjects;
  const [shuffledProjects, setShuffledProjects] = useState([]);
  const [hoverIndex, setHoverIndex] = useState(-1);

  const isMobile = window.innerWidth < 700

  const ProjectTitleStyle = {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    marginBottom: '0.75rem',
    color: '#fff',
    marginTop: isMobile ? '1rem' : '0rem'
  };

  useEffect(() => {
    const shuffledArray = [...projects];
    for (let i = shuffledArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
    }
    setShuffledProjects(shuffledArray);
  }, [projects]);
  

  return (
    <Container>
      <Content2Xl>
        <Heading>{heading}</Heading>
        <SubHeading>{subheading}</SubHeading>
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={30}
          slidesPerView={3}
          navigation={{
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          }}
          pagination={{ clickable: true, dynamicBullets: true }}
          autoplay={{ delay: 5000 }}
          breakpoints={{
            0: { slidesPerView: 1 },
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          style={{
            marginBottom: '4rem',
            padding: '2rem 0',
            paddingLeft: isMobile ? '0rem' : '1rem',
            paddingRight: isMobile ? '0rem' : '1rem',
            '& .swiper-pagination-bullet': {
              background: '#4A90E2',
            },
            '& .swiper-pagination-bullet-active': {
              background: '#2563EB',
            },
          }}
        >
          {shuffledProjects.map((project, index) => (
            <SwiperSlide key={index}>
              <div
                style={{
                  ...ProjectCardStyle,
                  ...(hoverIndex === index ? ProjectCardHoverStyle : {}),
                }}
                onMouseEnter={() => setHoverIndex(index)}
                onMouseLeave={() => setHoverIndex(-1)}
              >
                <span style={CategoryLabelStyle}>{project.category}</span>
                <div>
                  <h3 style={ProjectTitleStyle}>{project.title}</h3>
                  <p style={ProjectDescriptionStyle}>{project.description}</p>
                </div>
                {project.link.includes('marketplace') ? (
                  <a
                    href={project.link}
                    rel="noopener noreferrer"
                    style={{
                      ...ReadMoreButtonStyle,
                      ...(hoverIndex === index ? ReadMoreButtonHoverStyle : {}),
                    }}
                  >
                    Read More
                  </a>
                ) : (
                  <Link
                    to={project.link}
                    style={{
                      ...ReadMoreButtonStyle,
                      ...(hoverIndex === index ? ReadMoreButtonHoverStyle : {}),
                    }}
                  >
                    Read More
                  </Link>
                )}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <button
          style={isMobile ? {display: 'none'} : { left: '0', marginLeft: '1rem' }}
          className="swiper-button-prev"
        ></button>
        <button
          style={isMobile ? {display: 'none'} : { right: '0', marginRight: '1rem' }}
          className="swiper-button-next"
        ></button>
      </Content2Xl>
    </Container>
  );
};

export default CommunityProjects;
